import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';

import { NgbTimepickerModule } from '@ng-bootstrap/ng-bootstrap';

import { InputTimepickerSharedComponent } from './input.timepicker.component';

@NgModule({
    declarations: [
        InputTimepickerSharedComponent
    ],
    imports: [
        FormsModule,
        CommonModule,
        NgbTimepickerModule.forRoot()
    ],
    exports: [
        InputTimepickerSharedComponent
    ]
})

export class InputTimepickerSharedModule {}
